import { styled } from "@mui/material";

export const Container = styled("div")<{ bgImageUrl?: string }>`
	position: relative;
	min-height: 60vh;
	width: 100%;
	background-image: url(${(props) => props.bgImageUrl});
	background-size: cover;
	background-position: left;
	background-repeat: no-repeat;

	@media (orientation: landscape) {
		min-height: 80vh;
		background-position: center;
	}
`;

export const NoSessionContent = styled("div")`
	display: flex;
	flex-direction: column;
	min-height: 65vh;
	width: 100%;

	@media (orientation: landscape) {
		min-height: 80vh;
		background-position: center;
	}
`;

export const LoginBoxWrapper = styled("div")`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
`;
